module.exports = __webpack_public_path__ + "img/always_up_to_datee.17c24f6c.png";